<template>
    <div>
        <dialog-confirm ref="confirm"></dialog-confirm>

        <v-tooltip bottom v-if="$user.user.id === post.userID ||
                                            $root.check_mod()">
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                        v-if="post.disabled ==='0'"
                        v-bind="attrs"
                        v-on="on"
                        @click="mark_as_expired"
                        color="red">
                    mdi-clock-time-eleven-outline
                </v-icon>
            </template>
            <span v-html="$th('dialog-post.mark-as-expired')"></span>
        </v-tooltip>
    </div>
</template>

<script>
    export default {
        props  : ["post"],
        data() {
            return {
                dialog: false,
            }
        },
        methods: {
            async mark_as_expired() {
                if (await this.$refs.confirm.open(this.$t("dialog-post.dialog-confirm.mark-expired"), this.$t("dialog-post.dialog-confirm.mark-expired-are-you-sure"))) {
                    if (this.$user.user.id === this.post.userID || this.$root.check_mod()) {
                        let response = await this.func.ax("/php/post_mark_as_expired.php", {
                            postid: this.post.ID,
                            userid: this.$user.user.id,
                            token : this.$user.user.token,
                        });
                        await this.$root.check_response(response, () => {
                            this.$emit("post_marked_as_expired", this.post.ID);
                            this.eventbus.$emit("SB", "dialog-post.msg.post-marked-as-expired", "success", 5);
                        }, "dialog-post.msg.post-mark-as-expired-failed");

                        this.dialog = false;
                    }
                }
            },
        }
    }
</script>